import mixpanel from 'services/mixpanel';

export const useMixpanel = () => {
  const track = (event: string, data?: Record<string, any>) => {
    mixpanel.track(event, data);
  };

  const pageView = (page: string, userId?: string) => {
    track('Page Viewed', { page, userId });
  };

  const chatInteraction = (
    deviceId: string,
    action: 'thread' | 'message-sent' | 'filter-selected',
    extra?: any
  ) => {
    track('Chat Interaction', { deviceId, action, ...extra });
  };

  const contentSent = (
    deviceId: string,
    contentType: 'text' | 'audio' | 'photo-or-video' | 'document'
  ) => {
    track('Chat Content Sent', { deviceId, contentType });
  };

  return {
    track,
    pageView,
    chatInteraction,
    contentSent
  };
};
